import { useEffect, useRef } from "react"

// Same as useEffect but doesn't run when the component first renders. Only after the dependencies are updated.

export default function useUpdateEffect(callback: any, dependencies: any) {
    const firstRenderRef = useRef(true)

    useEffect(() => {
        if (firstRenderRef.current) {
            firstRenderRef.current = false
            return
        }
        return callback()
    }, dependencies)
}